module.exports = __webpack_public_path__ + "static/media/trasferir_llamada.20117cae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/TransferCall/trasferir_llamada.svg
// module id = 1844
// module chunks = 0